// src/components/Steps.js
import { Children, cloneElement } from "react";

function Steps({ children, currentStep }) {
    // Filtrar hijos válidos (elimina null, undefined, false, etc.)
    const validSteps = Children.toArray(children).filter(Boolean);
    
    return (
        <>
            {validSteps[currentStep] && cloneElement(validSteps[currentStep])}
        </>
    );
}

export default Steps;

